// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2aWSc","signatureBlock":"Footer_signatureBlock__1kJHP","signature":"Footer_signature__3J0h_"};